/* tslint:disable */
/* eslint-disable */
/**
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface CreateScheduleEventData
 */
export interface CreateScheduleEventData {
    /**
     * 
     * @type {string}
     * @memberof CreateScheduleEventData
     */
    description?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CreateScheduleEventData
     */
    title: string;
    /**
     * 
     * @type {Date}
     * @memberof CreateScheduleEventData
     */
    dateEnd: Date;
    /**
     * 
     * @type {Date}
     * @memberof CreateScheduleEventData
     */
    dateStart: Date;
    /**
     * What type(s) this schedule event is
     * @type {Array<string>}
     * @memberof CreateScheduleEventData
     */
    types: Array<CreateScheduleEventDataTypesEnum>;
    /**
     * The IDs of the schedules to apply this annotation to
     * @type {Array<number>}
     * @memberof CreateScheduleEventData
     */
    schedules?: Array<number>;
}

/**
* @export
* @enum {string}
*/
export enum CreateScheduleEventDataTypesEnum {
    Announcement = 'Announcement',
    BusinessClosed = 'BusinessClosed',
    LeaveRestricted = 'LeaveRestricted'
}


/**
 * Check if a given object implements the CreateScheduleEventData interface.
 */
export function instanceOfCreateScheduleEventData(value: object): value is CreateScheduleEventData {
    if (!('title' in value) || value['title'] === undefined) return false;
    if (!('dateEnd' in value) || value['dateEnd'] === undefined) return false;
    if (!('dateStart' in value) || value['dateStart'] === undefined) return false;
    if (!('types' in value) || value['types'] === undefined) return false;
    return true;
}

export function CreateScheduleEventDataFromJSON(json: any): CreateScheduleEventData {
    return CreateScheduleEventDataFromJSONTyped(json, false);
}

export function CreateScheduleEventDataFromJSONTyped(json: any, ignoreDiscriminator: boolean): CreateScheduleEventData {
    if (json == null) {
        return json;
    }
    return {
        
        'description': json['description'] == null ? undefined : json['description'],
        'title': json['title'],
        'dateEnd': (new Date(json['dateEnd'])),
        'dateStart': (new Date(json['dateStart'])),
        'types': json['types'],
        'schedules': json['schedules'] == null ? undefined : json['schedules'],
    };
}

  export function CreateScheduleEventDataToJSON(json: any): CreateScheduleEventData {
      return CreateScheduleEventDataToJSONTyped(json, false);
  }

  export function CreateScheduleEventDataToJSONTyped(value?: CreateScheduleEventData | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'description': value['description'],
        'title': value['title'],
        'dateEnd': ((value['dateEnd']).toISOString()),
        'dateStart': ((value['dateStart']).toISOString()),
        'types': value['types'],
        'schedules': value['schedules'],
    };
}

